import { createI18n } from 'vue-i18n';
import defaultData from './defaulti18data';

const i18n = createI18n({
  legacy: true,
  globalInjection: true,
  locale: 'en',
  fallbackLocale: 'en',
  messages: JSON.parse(JSON.stringify(defaultData)),
  pluralizationRules: {
    ru: function(choice, choicesLength) {
      if (choice === 0) {
        return 0;
      }

      const teen = choice > 10 && choice < 20;
      const endsWithOne = choice % 10 === 1;
      if (!teen && endsWithOne) {
        return 1;
      }
      if (!teen && choice % 10 >= 2 && choice % 10 <= 4) {
        return 2;
      }

      return choicesLength < 4 ? 2 : 3;
    },
  },
});

export default i18n;
